var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Header',{attrs:{"app":"","clipped-left":"","userInfo":_vm.user,"appName":_vm.appName}})
}
var staticRenderFns = []

export { render, staticRenderFns }